<template>
<div class="credit">
  <div>
    <h4>Subscription Plan</h4>
    <p style="font-weight:500;color:teal">{{plan.planName}}-{{plan.price/100}}$/month</p>
    </div>
      <h4>Payment Information</h4>
      <div ref="card"></div>
     <b-button variant="danger" style="margin-top:15px;margin-bottom:15px"
 @click="purchase">
    Pay with Card  <b-spinner v-if="pay==true" small type="grow"></b-spinner>

  </b-button>

</div>
</template>
<script>
import Vue from "vue";
import firebase from "firebase";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import moment from "moment";
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
let stripe = Stripe(`pk_test_51JVcs4SDtYRnBqE4a04FjUuryKgGzmkR0ReS7URp8YeiF8ft8Fgklu9d0brdVdzXphqNegBdpwnzYPExIxGC8K1w00YYFxjBYX`),
    elements = stripe.elements(),
    card = undefined;
let style = {
  base: {
    border: '1px solid #D8D8D8',
    borderRadius: '4px',
    color: "#000",
  },

  invalid: {
    // All of the error styles go inside of here.
  }

};
export default {
  data(){
    return{
plan:{},
amount:any,
pay:false
    }
  },
  mounted: function () {
    card = elements.create('card',style);
    card.mount(this.$refs.card);
  },
  methods:{
        purchase() {
          this.pay=true;
  let self = this;

  stripe.createToken(card).then(function(result) {
    console.log(result.token)
    if (result.error) {
      self.hasCardErrors = true;
      self.$forceUpdate();
      self.pay=false // Forcing the DOM to update so the Stripe Element can update.
      return;
    }else{
      self.pay=false;
      
                var stripeObject = {
               amount: self.plan.price,
               source: {
                 card:{
                 brand:result.token.card.brand,
                 last4:result.token.card.last4,
                 created:firebase.firestore.Timestamp.fromDate(new Date()).toDate()
                 },
                 id:result.token.id},
               plan:self.plan,
              id: firebase.auth().currentUser.uid,
              nextbilling:moment().add(30,'days').valueOf()
           }
             self.saveDataToFireStore(stripeObject)

    }
  });

  },
  saveDataToFireStore(stripeObject) {
 const db = firebase.firestore()
 const chargesRef = db.collection("charges")
 const pushId = chargesRef.doc().id
 db.collection("charges").doc(pushId).set(stripeObject)
        .then(() => {

          Vue.$toast.success("User registered successfully", {
            position: "top-right",
          });
            localStorage.clear();
            this.$router.push({ name: "Landing" })

        })
        .catch((error) => {
          Vue.$toast.error("Registration failed", {
            position: "top-right",
          });
        });

}

  },
    created: function () {
    this.plan = JSON.parse(localStorage.getItem("PlanDetails"))
    console.log("this.proimg",this.plan)

  },

}
</script>
<style scoped>
.credit{
  width:25rem;
    border: 1px solid gainsboro;
  height: fit-content;
  padding: 1rem;
  margin-left: auto;
  margin-right: auto;
margin-top:10rem;
margin-bottom:10rem;
padding-top:2rem;
padding-bottom: 2rem;
}
</style>